const getInitialState = () => ({
  attemptedKey: {
    character: '',
    expected: '',
    isCorrect: false,
    withCmd: false,
    withShift: false
  },
  progress: {
    currentText: '',
    currentIndex: 0
  },
  isFreeTextTyping: false
});

export default getInitialState;
